import {
  Box,
  HStack,
  Skeleton,
  Stack,
  useBreakpointValue,
  useColorModeValue,
  VStack,
  Text,
  Badge,
  IconButton,
  Button,
} from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import { FiChevronRight } from 'react-icons/fi';
import { Settings } from '../../interfaces';
import { CustomTable } from '../molecules/CustomTable';

export interface PlayerHubProps {
  PlayerHubTableFields: PlayerHubTableField[];
  settings?: Settings;
  onTicketClick?: (issueId: number, status: 'Active' | 'resolved' | 'rejected') => void;
  emptyDataHelperText: string;
  // inputValue?: string;
  isPreview?: boolean;
  ticketHref?: (issueId: number, status: 'Active' | 'resolved' | 'rejected') => string;
  getTicketData?: (issueId: number) => any;
}

export interface PlayerHubTableField {
  ticketNumber: number;
  ticketSummary: string;
  status: string;
  date: string;
}

// export const PlayerHub: React.FC<PlayerHubProps> = ({
//   PlayerHubTableFields,
//   settings,
//   onTicketClick,
//   emptyDataHelperText,
//   // inputValue,
// }) => {
//   const [loading, setLoading] = useState<boolean>(true);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setLoading(false);
//     }, 5000);
//     return () => clearTimeout(timer);
//   }, [PlayerHubTableFields]);

//   // const filteredTableData = PlayerHubTableFields.filter(field =>
//   //   field.ticketSummary.toLowerCase().includes(inputValue.toLowerCase()),
//   // ).map(field => {
//   //   let formattedDate = field.date;
//   //   if (field.date !== '-') {
//   //     const parsed = Date.parse(field.date);
//   //     if (!Number.isNaN(parsed)) {
//   //       const dateObj = new Date(parsed);
//   //       formattedDate = dateObj
//   //         .toLocaleDateString('en-US', {
//   //           month: 'short', // Jan
//   //           day: '2-digit', // 18
//   //           year: 'numeric', // 2025
//   //         })
//   //         .replace(/(\w+)\s(\d{2}),\s(\d{4})/, '$1-$2-$3');
//   //     }
//   //   }

//   //   return {
//   //     'Ticket #': field.ticketNumber,
//   //     'Ticket Summary': field.ticketSummary,
//   //     Status: field.status,
//   //     'Last Updated': formattedDate,
//   //   };
//   // });

//   // Instead of filtering again, just map PlayerHubTableFields directly
//   const filteredTableData = PlayerHubTableFields.map(field => {
//     let formattedDate = field.date;
//     if (field.date !== '-') {
//       const parsed = Date.parse(field.date);
//       if (!Number.isNaN(parsed)) {
//         const dateObj = new Date(parsed);
//         formattedDate = dateObj
//           .toLocaleDateString('en-US', {
//             month: 'short',
//             day: '2-digit',
//             year: 'numeric',
//           })
//           .replace(/(\w+)\s(\d{2}),\s(\d{4})/, '$1-$2-$3');
//       }
//     }

//     return {
//       'Ticket #': field.ticketNumber,
//       'Ticket Summary': field.ticketSummary,
//       Status: field.status,
//       'Last Updated': formattedDate,
//     };
//   });

//   let content;
//   if (loading) {
//     content = (
//       <Box mt={{ base: '2rem', md: '3rem' }} fontSize="lg" textAlign="center" color="gray.500">
//         Loading...
//       </Box>
//     );
//   } else if (filteredTableData.length > 0) {
//     content = (
//       <CustomTable
//         height={{ base: 'auto', md: '50vh' }}
//         mt={{ base: '4vh', md: '5vh' }}
//         fields={['Ticket #', 'Ticket Summary', 'Status', 'Last Updated']}
//         fieldsWithIcons={['Ticket #', 'Status', 'Last Updated']}
//         fieldsAsLinks={['Ticket #']}
//         centerAlignFields={['Status']}
//         rowBorderColor="#dedede"
//         data={filteredTableData}
//         rowHoverBgColor={settings?.configs.tertiaryAccentColor}
//         tableRowTextColor={settings?.configs.primaryTextColor}
//         tableHeadingTextColor={settings?.configs.tableHeadingTextColor}
//         primaryAccentColor={settings?.configs.primaryAccentColor}
//         secondaryAccentColor={settings?.configs.secondaryAccentColor}
//         tertiaryAccentColor={settings?.configs.tertiaryAccentColor}
//         onTicketClick={onTicketClick}
//         emptyDataHelperText={emptyDataHelperText}
//       />
//     );
//   } else {
//     content = (
//       <Box mt={{ base: '2rem', md: '3rem' }} fontSize="lg" textAlign="center" color="gray.500">
//         No issues found.
//       </Box>
//     );
//   }

//   return (
//     <Box
//       px={{ base: '2rem', md: '5rem', lg: '12rem' }}
//       py={{ base: '2rem', md: '3rem' }}
//       maxW="100%"
//       width="100%"
//     >
//       {content}
//     </Box>
//   );
// };

// export const PlayerHub: React.FC<PlayerHubProps> = ({
//   PlayerHubTableFields,
//   settings,
//   onTicketClick,
//   emptyDataHelperText,
// }) => {
//   const [loading, setLoading] = useState<boolean>(true);
//   const [expandedTicket, setExpandedTicket] = useState<number | null>(null);

//   // small screens will show card list; md+ will show the table
//   const isSmall = useBreakpointValue({ base: true, md: false });

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setLoading(false);
//     }, 5000);
//     return () => clearTimeout(timer);
//   }, [PlayerHubTableFields]);

//   // Format rows same as before
//   const formattedData = PlayerHubTableFields.map(field => {
//     let formattedDate = field.date;
//     if (field.date !== '-') {
//       const parsed = Date.parse(field.date);
//       if (!Number.isNaN(parsed)) {
//         const dateObj = new Date(parsed);
//         formattedDate = dateObj
//           .toLocaleDateString('en-US', {
//             month: 'short',
//             day: '2-digit',
//             year: 'numeric',
//           })
//           .replace(/(\w+)\s(\d{2}),\s(\d{4})/, '$1-$2-$3');
//       }
//     }

//     return {
//       ticketNumber: field.ticketNumber,
//       ticketSummary: field.ticketSummary,
//       status: field.status,
//       lastUpdated: formattedDate,
//       raw: field,
//     };
//   });

//   // UI colors
//   const cardBg = useColorModeValue(settings?.configs?.cardBg ?? '#ffffff', 'gray.800');
//   const cardBorder = useColorModeValue('#e6e6e6', 'gray.700');
//   const primaryText = settings?.configs?.primaryTextColor ?? 'black';
//   const secondaryText = 'gray.600';
//   const accent = settings?.configs?.primaryAccentColor ?? '#2b6cb0';
//   const tertiary = settings?.configs?.tertiaryAccentColor ?? '#f0f4ff';

//   // Loading state (skeleton) — same behavior but more mobile-friendly
//   if (loading) {
//     return (
//       <Box px={{ base: '1.5rem', md: '5rem' }} py="2rem" maxW="100%" width="100%">
//         <Stack spacing={4}>
//           <Skeleton height="72px" borderRadius="md" />
//           <Skeleton height="72px" borderRadius="md" />
//           <Skeleton height="72px" borderRadius="md" />
//         </Stack>
//       </Box>
//     );
//   }

//   // Empty data UI
//   if (!formattedData || formattedData.length === 0) {
//     return (
//       <Box
//         px={{ base: '1.5rem', md: '5rem' }}
//         py={{ base: '2rem', md: '3rem' }}
//         maxW="100%"
//         width="100%"
//       >
//         <Box mt={{ base: '1.5rem', md: '3rem' }} fontSize="lg" textAlign="center" color="gray.500">
//           {emptyDataHelperText ?? 'No issues found.'}
//         </Box>
//       </Box>
//     );
//   }

//   // Show cards on small screens
//   if (isSmall) {
//     return (
//       <Box px={{ base: '1rem' }} py="1rem" maxW="100%" width="100%">
//         <VStack spacing={3} align="stretch">
//           {formattedData.map(item => {
//             const isExpanded = expandedTicket === item.ticketNumber;
//             return (
//               <Box
//                 key={item.ticketNumber}
//                 border="1px solid"
//                 borderColor={cardBorder}
//                 bg={cardBg}
//                 borderRadius="md"
//                 p={3}
//                 role="group"
//                 _hover={{ boxShadow: 'sm' }}
//                 onClick={() => {
//                   // toggle expansion
//                   setExpandedTicket(prev =>
//                     prev === item.ticketNumber ? null : item.ticketNumber,
//                   );
//                 }}
//               >
//                 <HStack justify="space-between" align="start">
//                   <VStack align="start" spacing={1}>
//                     <HStack spacing={2} align="center">
//                       <Text fontSize="sm" fontWeight="700" color={primaryText}>
//                         #{item.ticketNumber}
//                       </Text>
//                       <Badge
//                         fontSize="xs"
//                         px={2}
//                         py="2px"
//                         borderRadius="full"
//                         bg={tertiary}
//                         color={primaryText}
//                       >
//                         {item.status}
//                       </Badge>
//                     </HStack>

//                     <Text fontSize="sm" color={secondaryText} noOfLines={2}>
//                       {item.ticketSummary}
//                     </Text>

//                     <Text fontSize="xs" color="gray.500">
//                       Last updated: {item.lastUpdated}
//                     </Text>
//                   </VStack>

//                   <IconButton
//                     aria-label={isExpanded ? 'Collapse' : 'Expand'}
//                     icon={isExpanded ? <FiChevronDown /> : <FiChevronRight />}
//                     size="sm"
//                     variant="ghost"
//                     onClick={e => {
//                       e.stopPropagation();
//                       setExpandedTicket(prev =>
//                         prev === item.ticketNumber ? null : item.ticketNumber,
//                       );
//                     }}
//                   />
//                 </HStack>

//                 {/* Expanded details area (touch-friendly) */}
//                 <Collapse in={isExpanded} animateOpacity>
//                   <Box mt={3} pt={3} borderTop="1px dashed" borderColor={cardBorder}>
//                     <Text fontSize="sm" color={primaryText} mb={2}>
//                       <strong>Summary:</strong> {item.ticketSummary}
//                     </Text>

//                     {/* Add any extra fields or actions */}
//                     <HStack spacing={3} mt={2}>
//                       <Box
//                         as="button"
//                         onClick={() => onTicketClick(item.raw)}
//                         style={{ cursor: 'pointer' }}
//                       >
//                         <Text fontSize="sm" color={accent} fontWeight="600">
//                           View ticket
//                         </Text>
//                       </Box>
//                       {/* more actions can go here */}
//                     </HStack>
//                   </Box>
//                 </Collapse>
//               </Box>
//             );
//           })}
//         </VStack>
//       </Box>
//     );
//   }

//   // Default: show the table for md+ screens (keeps existing CustomTable usage)
//   return (
//     <Box
//       px={{ base: '2rem', md: '5rem', lg: '12rem' }}
//       py={{ base: '2rem', md: '3rem' }}
//       maxW="100%"
//       width="100%"
//     >
//       <CustomTable
//         height={{ base: 'auto', md: '50vh' }}
//         mt={{ base: '4vh', md: '5vh' }}
//         fields={['Ticket #', 'Ticket Summary', 'Status', 'Last Updated']}
//         fieldsWithIcons={['Ticket #', 'Status', 'Last Updated']}
//         fieldsAsLinks={['Ticket #']}
//         centerAlignFields={['Status']}
//         rowBorderColor="#dedede"
//         data={formattedData.map(d => ({
//           'Ticket #': d.ticketNumber,
//           'Ticket Summary': d.ticketSummary,
//           Status: d.status,
//           'Last Updated': d.lastUpdated,
//           raw: d.raw,
//         }))}
//         rowHoverBgColor={settings?.configs.tertiaryAccentColor}
//         tableRowTextColor={settings?.configs.primaryTextColor}
//         tableHeadingTextColor={settings?.configs.tableHeadingTextColor}
//         primaryAccentColor={settings?.configs.primaryAccentColor}
//         secondaryAccentColor={settings?.configs.secondaryAccentColor}
//         tertiaryAccentColor={settings?.configs.tertiaryAccentColor}
//         onTicketClick={onTicketClick}
//         emptyDataHelperText={emptyDataHelperText}
//       />
//     </Box>
//   );
// };

export const PlayerHub: React.FC<PlayerHubProps> = ({
  PlayerHubTableFields,
  settings,
  onTicketClick,
  emptyDataHelperText,
  isPreview = false,
  ticketHref,
  getTicketData,
}) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [showAll, setShowAll] = useState<boolean>(false); // new: show rest on mobile

  // small screens will show card list; md+ will show the table
  const isSmall = useBreakpointValue({ base: true, md: false });

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, [PlayerHubTableFields]);

  // Format rows same as before — keep ticketNumber as string for keys/UI
  const formattedData = PlayerHubTableFields.map(field => {
    let formattedDate = field.date;
    if (field.date !== '-') {
      const parsed = Date.parse(field.date);
      if (!Number.isNaN(parsed)) {
        const dateObj = new Date(parsed);
        formattedDate = dateObj.toLocaleDateString('en-US', {
          month: 'long',
          day: '2-digit',
          year: 'numeric',
        });
        // .replace(/(\w+)\s(\d{2}),\s(\d{4})/, '$1-$2-$3');
      }
    }

    return {
      ticketNumber: String(field.ticketNumber),
      ticketSummary: field.ticketSummary,
      status: field.status,
      lastUpdated: formattedDate,
      raw: field,
    };
  });

  const handleTableClick = (...args: any[]) => {
    let ticketVal: string | number | undefined;
    let rowData: any;

    if (args.length === 0) return;

    // heuristic 1: plain value
    if (typeof args[0] === 'string' || typeof args[0] === 'number') {
      // eslint-disable-next-line prefer-destructuring
      ticketVal = args[0];
      rowData = args[1] ?? undefined;
    }

    // heuristic 2: first arg looks like row object
    if (!ticketVal && typeof args[0] === 'object' && args[0] !== null) {
      const obj = args[0];
      ticketVal = obj['Ticket #'] ?? obj.ticketNumber ?? obj.ticket_id ?? obj.id;
      rowData = obj;
    }

    // heuristic 3: second arg is row object (common: onClick(rowIndex, rowData))
    if (!ticketVal && args.length > 1 && typeof args[1] === 'object') {
      const obj = args[1];
      ticketVal = obj['Ticket #'] ?? obj.ticketNumber ?? obj.ticket_id ?? obj.id;
      rowData = obj;
    }

    // nothing found — as fallback, log the args to help debugging
    if (!ticketVal) {
      // eslint-disable-next-line no-console
      console.warn('handleTableClick: unable to find ticket number from args', args);
      return;
    }

    // normalize to string
    const ticketNumberStr = String(ticketVal);

    // find the full formatted row in your formattedData array (so we can pass status/raw)
    const found = formattedData.find(d => String(d.ticketNumber) === ticketNumberStr) ?? rowData;

    // now call your original onTicketClick in the same shape mobile used:
    // mobile used: onTicketClick(issueId, item.raw.status)
    // convert ticketNumber to number if that is what your handler expects
    const issueId = Number(ticketNumberStr);
    const status = found?.raw?.status ?? found?.status ?? undefined;

    // finally call the prop handler if provided
    if (typeof onTicketClick === 'function') {
      onTicketClick(issueId, status);
    } else {
      // eslint-disable-next-line no-console
      console.warn('onTicketClick prop is not a function', onTicketClick);
    }
  };

  // UI colors — safe fallbacks
  const lightCardBg = '#ffffff';
  const darkCardBg = 'gray.800';
  const cardBg = useColorModeValue(lightCardBg, darkCardBg);
  const cardBorder = useColorModeValue('#e6e6e6', 'gray.700');
  const primaryText = settings?.configs?.primaryTextColor ?? 'black';
  const secondaryText = 'gray.600';
  const tertiary = settings?.configs?.tertiaryAccentColor ?? '#f0f4ff';

  // Loading skeleton
  if (loading) {
    return (
      <Box px={{ base: '1.5rem', md: '5rem' }} py="2rem" maxW="100%" width="100%">
        <Stack spacing={4}>
          <Skeleton height="72px" borderRadius="md" />
          <Skeleton height="72px" borderRadius="md" />
          <Skeleton height="72px" borderRadius="md" />
        </Stack>
      </Box>
    );
  }

  // Empty data UI
  if (!formattedData || formattedData.length === 0) {
    return (
      <Box
        px={{ base: '1.5rem', md: '5rem' }}
        py={{ base: '2rem', md: '3rem' }}
        maxW="100%"
        width="100%"
      >
        <Box mt={{ base: '1.5rem', md: '3rem' }} fontSize="lg" textAlign="center" color="gray.500">
          {emptyDataHelperText ?? 'No issues found.'}
        </Box>
      </Box>
    );
  }

  // Small screens: show tappable cards (no expansion — tapping opens ticket)
  if (isSmall) {
    // show only first 6 unless showAll is true
    const MAX_TILES = 6;
    const visibleData = showAll ? formattedData : formattedData.slice(0, MAX_TILES);
    const remainingCount = Math.max(0, formattedData.length - MAX_TILES);

    return (
      <Box px={{ base: '1rem' }} py="1rem" maxW="100%" width="100%">
        <VStack spacing={3} align="stretch">
          {visibleData.map(item => {
            const openTicket = () => {
              if (typeof onTicketClick === 'function') {
                const issueId = Number(item.raw.ticketNumber);
                if (!Number.isNaN(issueId)) {
                  onTicketClick(issueId, item.raw.status as any);
                }
              }
            };

            return (
              <Box
                key={item.ticketNumber}
                border="1px solid"
                borderColor={cardBorder}
                bg={cardBg}
                borderRadius="md"
                p={3}
                role="button"
                onClick={openTicket}
                _hover={{ boxShadow: 'sm', cursor: 'pointer' }}
                aria-label={`Open ticket ${item.ticketNumber}`}
              >
                <HStack justify="space-between" align="start">
                  <VStack align="start" spacing={1}>
                    <HStack spacing={2} align="center">
                      <Text fontSize="sm" fontWeight="700" color={primaryText}>
                        #{item.ticketNumber}
                      </Text>

                      <Badge
                        fontSize="xs"
                        px={2}
                        py="2px"
                        borderRadius="full"
                        bg={tertiary}
                        color={primaryText}
                      >
                        {item.status}
                      </Badge>
                    </HStack>

                    <Text fontSize="sm" color={secondaryText} noOfLines={2}>
                      {item.ticketSummary}
                    </Text>

                    <Text fontSize="xs" color="gray.500">
                      Last updated: {item.lastUpdated}
                    </Text>
                  </VStack>

                  <IconButton
                    aria-label="Open ticket"
                    icon={<FiChevronRight />}
                    size="sm"
                    variant="ghost"
                    onClick={e => {
                      e.stopPropagation();
                      openTicket();
                    }}
                  />
                </HStack>
              </Box>
            );
          })}

          {/* View more / View less button */}
          {formattedData.length > MAX_TILES && (
            <Box textAlign="center" pt={2}>
              <Button
                size="sm"
                variant="ghost"
                onClick={() => setShowAll(prev => !prev)}
                aria-expanded={showAll}
              >
                {showAll ? 'View less' : `View more (${remainingCount})`}
              </Button>
            </Box>
          )}
        </VStack>
      </Box>
    );
  }

  // md+ show table (preserve original CustomTable usage)
  // md+ show table (preserve original CustomTable usage)
  return (
    <Box
      px={{ base: '2rem', md: '5rem', lg: '12rem' }}
      py={{ base: '1rem', md: '1.5rem' }} // reduced vertical padding
      maxW="100%"
      width="100%"
    >
      <CustomTable
        height={{ base: 'auto', md: '50vh' }}
        mt={{ base: '1rem', md: '1.5rem' }} // reduced space above the table
        fields={['Ticket #', 'Ticket Summary', 'Status', 'Last Updated']}
        fieldsWithIcons={['Ticket #', 'Status', 'Last Updated']}
        fieldsAsLinks={['Ticket #']}
        centerAlignFields={['Status']}
        rowBorderColor="#dedede"
        data={formattedData.map(d => ({
          'Ticket #': d.ticketNumber,
          'Ticket Summary': d.ticketSummary,
          Status: d.status,
          'Last Updated': d.lastUpdated,
          raw: d.raw,
        }))}
        rowHoverBgColor={settings?.configs.tertiaryAccentColor}
        tableRowTextColor={settings?.configs.primaryTextColor}
        tableHeadingTextColor={settings?.configs.tableHeadingTextColor}
        primaryAccentColor={settings?.configs.primaryAccentColor}
        secondaryAccentColor={settings?.configs.secondaryAccentColor}
        tertiaryAccentColor={settings?.configs.tertiaryAccentColor}
        onTicketClick={handleTableClick}
        emptyDataHelperText={emptyDataHelperText}
        isPreview={isPreview}
        ticketHref={ticketHref}
        getTicketData={getTicketData}
      />
    </Box>
  );
};
